import {all, fork, put, takeLatest} from "redux-saga/effects";
import {FALLBACK_LANGUAGE} from "../../../Constants/Defaults";
import {BaseRequest} from "../../../lib/http";
import {isProduction} from "../../../lib/utils";
import {loadLanguage} from "./actions";
import * as Types from "./types";

const hash = process.env.REACT_APP_I18N_HASH || "";

function* changeLanguageRequest() {
    yield takeLatest(Types.INTERNALIZATION_CHANGE_LANGUAGE, function* (action) {
        const prefix = process.env.APP_LANG_PREFIX || "apparel";
        const code = action.payload || navigator.language || FALLBACK_LANGUAGE;
        let filename = "translations";

        if (hash && isProduction()) {
            filename = hash;
        }

        filename = `/lang/${code}/${filename}.json`;

        try {
            const config = yield BaseRequest.get(filename);

            yield put(
                loadLanguage({
                    file: config.data,
                    prefix,
                })
            );
        } catch (e) {
            yield put(
                loadLanguage({
                    file: {},
                    prefix,
                })
            );
        }
    });
}

export default function* AuthSaga() {
    yield all([fork(changeLanguageRequest)]);
}
